export const parseUomOptions = ({ serviceResponse }) => {
  return serviceResponse !== undefined && serviceResponse.length !== 0
    ? serviceResponse?.map(item => ({ value: item?.id, label: item?.description }))
    : [];
};
